import ColorConstants from '../../constants/ColorConstants';

export const DefaultScrollBar = `
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 0px rgba(0,0,0,0.3);
        background-color: ${ColorConstants.zircon};
    }
    &::-webkit-scrollbar {
        width: 5px;
        background-color: ${ColorConstants.zircon};
        border-radius: 20px;
    
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${ColorConstants['regal-blue']};
        border-radius: 20px;
    }
`;
